
export interface BackgroundFilterData {
  id: string;
  prompt_name: string;
  priority: number;
  tags: string[];
}

export const BACKGROUND_FILTERS: BackgroundFilterData[] = [
  {
    id: "bg-studio",
    prompt_name: "Studio Background",
    priority: 100,
    tags: ["professional", "clean"]
  },
  {
    id: "bg-nature",
    prompt_name: "Natural Setting",
    priority: 90,
    tags: ["outdoor", "organic"]
  },
  {
    id: "bg-urban",
    prompt_name: "Urban Environment",
    priority: 80,
    tags: ["city", "modern"]
  },
  {
    id: "bg-gradient",
    prompt_name: "Gradient Background",
    priority: 70,
    tags: ["abstract", "colorful"]
  },
  {
    id: "bg-textured",
    prompt_name: "Textured Surface",
    priority: 60,
    tags: ["material", "detailed"]
  },
  {
    id: "bg-minimalist",
    prompt_name: "Minimalist",
    priority: 50,
    tags: ["simple", "clean"]
  },
  {
    id: "bg-bokeh",
    prompt_name: "Bokeh Effect",
    priority: 40,
    tags: ["blurred", "artistic"]
  },
  {
    id: "bg-pattern",
    prompt_name: "Patterned Background",
    priority: 30,
    tags: ["geometric", "repetitive"]
  },
  {
    id: "bg-transparent",
    prompt_name: "Transparent",
    priority: 20,
    tags: ["isolated", "cutout"]
  },
  {
    id: "bg-vintage",
    prompt_name: "Vintage Style",
    priority: 10,
    tags: ["retro", "aged"]
  }
];
